import React from 'react';
import { useLocation } from 'react-router-dom';

import { APP_ROUTES, APP_TITLES } from '../../constants';

export const TitleUpdater = () => {
  const location = useLocation();
  const { pathname } = location;

  React.useEffect(() => {
    const key = Object.keys(APP_ROUTES).find((k) => APP_ROUTES[k]?.includes?.(pathname));
    let title = key ? APP_TITLES[key] : 'Safe Sense Portal';

    if (pathname.startsWith(APP_ROUTES.fleet.root)) {
      title = APP_TITLES.fleet;
    }
    if (pathname.startsWith(APP_ROUTES.fleetWizard.root)) {
      title = APP_TITLES.fleetWizard;
    }

    document.title = title;
  }, [pathname]);

  return [];
};
